
import { Component, Vue, Prop } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
import utility from '@/utility/utility';
import * as firebase from 'firebase';

@Component
export default class BillOfLading extends Vue {
    private eventEmit = {
        eventAddRow: 'eventAddRow',
        eventRemoveRow: 'eventRemoveRow'
    };

    @Prop({default: null})
    private listLadings: any;

    @Prop()
    private checkValid: any;

    private limit = 10000;
    private currentItem: any = null;
    private imageData: any = null;
    private uploadValue = 0;
    private hideImage = false;
    private hasCustomCode = false;
    private async addRow() {
        if (this.listLadings.length >= this.limit) {
            return false;
        }
        this.$emit(this.eventEmit.eventAddRow, null);
    }
    private checkBinCode() {
        const hasNonDash = this.listLadings.filter(l => l.binCode.indexOf('_') === -1);
        if (hasNonDash.length > 1) {
            this.hasCustomCode = true;
        } else {
            this.hasCustomCode = false;
        }
    }
    private async removeRow(id: string) {
        this.$emit(this.eventEmit.eventRemoveRow, id);
    }
    private getImages(index) {
        return this.listLadings[index].ProductImage ||  '';
    }
    private chooseImage(item) {
        this.currentItem = item;
        this.currentItem.ProductImage = '';
        (this.$refs as any).fileInput[0].click();
    }
    private previewImage(event) {
        this.uploadValue = 0;
        this.imageData = event.target.files[0];
        (this.$refs as any).fileInput[0].value = null;
        this.onUpload()
    }
    private onUpload() {
        const arrFileType = this.imageData.name.split('.');
        const storageRef=firebase.storage().ref(`${APP_CONFIG.settings.firebase_prefix}/${utility.randomString(35)}.${arrFileType[arrFileType.length - 1]}`).put(this.imageData);
        storageRef.on(`state_changed`, snapshot => {
                this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
            }, error => {
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: 'File ảnh chỉ được tối đa 1Mb!',
                });
            },
            () => {
                this.uploadValue=100;
                storageRef.snapshot.ref.getDownloadURL().then((url) => {
                    this.currentItem.ProductImage =url;
                    this.hideImage = true;
                    this.$nextTick(() => this.hideImage = false);
                });
            }
        );
    }
}
